import { Flex } from "@mantine/core";

import { spacing } from "#app/theme/v2/spacing";
import { Step } from "#components/atoms/Step/Step";

type StepperProps = {
  total: number;
  current: number;
};

export const Stepper = ({ total, current }: StepperProps) => (
  <Flex gap={spacing[4]} align="center">
    {Array.from({ length: total }, (_, index) => (
      <Step key={index} active={index + 1 === current} />
    ))}
  </Flex>
);
